const filtersList = [
  {
    field: {
      value: "ano",
      label: "Año",
      component: "select"
    },
    param: [],
    default_operator: "OR"
  },
  {
    field: {
      value: "descripcion",
      label: "Descripción de la compra",
      component: "text"
    },
    param: "",
    default_operator: "AND"
  },
  {
    field: {
      value: "pac_catalogo_electronico",
      label: "Catálogo Electrónico",
      component: "select"
    },
    param: [],
    default_operator: "OR"
  },
  {
    field: {
      value: "pac_tipo",
      label: "Tipo de Contratación",
      component: "select"
    },
    param: [],
    default_operator: "OR"
  },
  {
    field: {
      value: "provincia_entidad",
      label: "Provincia",
      component: "select"
    },
    param: [],
    default_operator: "OR"
  },
  {
    field: {
      value: "canton_entidad",
      label: "Cantón",
      component: "datatable",
      context: "query"
    },
    param: [],
    default_operator: "OR"
  },
  {
    field: {
      value: "periodo",
      label: "Periodos",
      component: "select",
      context: "filter"
    },
    param: [],
    default_operator: "OR"
  },
  {
    field: {
      value: "pac_tipo_regimen",
      label: "Régimen",
      component: "select",
      context: "filter"
    },
    param: [],
    default_operator: "OR"
  },
  {
    field: {
      value: "descripcion_cpc",
      label: "Código CPC",
      component: "datatable",
      context: "query"
    },
    param: [],
    default_operator: "OR"
  },
  {
    field: {
      value: "descripcion_cpc_full",
      label: "Descripción CPC Nivel 9",
      component: "datatable",
      context: "query"
    },
    param: [],
    default_operator: "OR"
  },
  {
    field: {
      value: "procedimiento",
      label: "Tipo de Proceso",
      component: "select"
    },
    param: [],
    default_operator: "OR"
  },
  {
    field: {
      value: "nombre_entidad",
      label: "Entidad Contratante",
      component: "datatable",
      context: "query"
    },
    param: [],
    default_operator: "OR"
  },
  {
    field: {
      value: "nombre_proveedor",
      label: "Nombre Proveedor",
      component: "datatable",
      context: "query"
    },
    param: [],
    default_operator: null
  },
  {
    field: {
      value: "region_entidad",
      label: "Región",
      component: "select",
      context: "filter"
    },
    param: [],
    default_operator: null
  },
  {
    field: {
      value: "pac_total",
      label: "Presupuesto Referencial",
      component: "range"
    },
    param: [],
    default_operator: "OR"
  }
];

export default filtersList;
